<!-- 底部组件 -->
<template>
    <div v-if="isShow">
        <div class="footerbox">
            <div class="common">
                <div class="footer_top">
                    <div class="contactbox">
                        <div class="footer_logo">
                            <img src="@/assets/img/index/footer_logo.png" alt="" />
                        </div>
                        <div class="content">
                            <div class="title">海南融汇南海科技有限公司</div>
                            <div class="font">服务热线：400-617-1118</div>
                            <div class="font">商务合作：swhz@ronghuinanhai.com</div>
                        </div>
                    </div>

                    <div class="enterpriseServices">
                        <div class="title">企业服务</div>
                        <div class="content">
                            <div class="item" @click="toqff()">企服福平台</div>
                            <div class="item" @click="toxxfp()">企服福销项系统</div>
                        </div>
                    </div>

                    <div class="governmentServices">
                        <div class="title">政府服务</div>
                        <div class="content">
                            <div class="item" @click="toDataCenter()">智慧数据中心</div>
                            <div class="item" @click="toIntegrated()">政务服务"一网通办"平台</div>
                        </div>
                    </div>

                    <!-- AI人工聚合 → 现在布局完全统一 -->
                    <div class="AIManualAggregation">
                        <div class="title">AI聚合平台</div>
                        <div class="content">
                            <div class="item" @click="toaiznjhpt()">智能聚合平台</div>
                            <div class="item" @click="toaizntyy()">智能体应用</div>
                        </div>
                    </div>

                    <div class="cooperationbox">
                        <div class="title">合作共赢</div>
                        <div class="content">
                            <div class="item" @click="cooperationShow = true">合作共赢</div>
                        </div>
                    </div>

                    <div class="aboutUsBox">
                        <div class="title">关于我们</div>
                        <div class="content">
                            <div class="item" @click="toAbout()">公司介绍</div>
                            <div class="item" @click="toAboutItem()">企业文化</div>
                            <div class="item" @click="toContactItem()">联系我们</div>
                        </div>
                    </div>

                    <div class="followUsBox">
                        <div class="title">关注我们</div>
                        <div class="content">
                            <img class="gongzhonghao" src="@/assets/img/index/erweimaFooter.jpg" alt="" />
                            <p>关注公众号</p>
                        </div>
                    </div>
                </div>

                <div class="footer_bottom">
                    <div class="item">版权所有：海南融汇南海科技有限公司</div>
                    <div class="item">
                        <a href="https://beian.miit.gov.cn/" target="_blank">备案号：琼ICP备2022002951号</a>
                    </div>
                    <div class="item">
                        <a href="https://www.beian.gov.cn/" target="_blank">琼公网安备46010602001641号 </a>
                    </div>
                </div>
            </div>
        </div>

        <cooperation-dialog v-if="cooperationShow" @closeCooperationDialog="cooperationShow = false"
            @openCooperationSuccessShow="cooperationSuccessShow = true"></cooperation-dialog>
        <cooperationsuccess-dialog v-if="cooperationSuccessShow" @closeDialog="cooperationSuccessShow = false"></cooperationsuccess-dialog>
    </div>
</template>

<script>
import cooperationDialog from '@/components/cooperation'
import cooperationsuccessDialog from '@/components/cooperationsuccess'
export default {
  components: { cooperationDialog, cooperationsuccessDialog },
  data() {
    return {
      isShow: false,
      cooperationShow: false,
      cooperationSuccessShow: false,
    }
  },
  methods: {
    toAboutItem() {
      localStorage.setItem('cec', 'cultureBox')
      this.$emit('toAbout')
      this.$router.push({ path: '/about' })
    },
    toContactItem() {
      this.$router.push({ path: '/contact', query: { date: new Date().getTime() } })
    },
    toAbout() {
      this.$router.push({ path: '/about', query: { date: new Date().getTime() } })
    },
    toContact() {
      this.$router.push({ path: '/contact', query: { date: new Date().getTime() } })
    },
    toqff() {
      this.$router.push({ path: '/qff', query: { date: new Date().getTime() } })
    },
    toxxfp() {
      this.$router.push({ path: '/xxfp', query: { date: new Date().getTime() } })
    },
    toaiznjhpt(){
      this.$router.push({ path:'/aiznjhpt', query:{ data:new Date().getTime() } })
    },
    toaizntyy(){
      this.$router.push({ path:'/aizntyy', query:{ data:new Date().getTime() } })
    },
    toDataCenter() {
      this.$router.push({ path: '/dataCenter', query: { date: new Date().getTime() } })
    },
    toIntegrated() {
      this.$router.push({ path: '/integrated', query: { date: new Date().getTime() } })
    },
  },
  created() {
    setTimeout(() => { this.isShow = true }, 1000)
  },
}
</script>

<style scoped lang="scss">
.footerbox {
  width: 100%;
  height: 408px;
  background: url('@/assets/img/header/footer_bg.png') 100% 100% repeat;

  .common {
    width: 1200px;
    margin: 0 auto;

    .footer_top {
      height: 308px;
      padding: 80px 0 40px;
      box-sizing: border-box;
      border-bottom: 1px solid #373d5c;
      display: flex;
      justify-content: space-between;
      align-items: flex-start; /* 所有模块顶部对齐 */
    }

    .contactbox {
      .footer_logo {
        width: 120px;
        height: 36px;
        margin-bottom: 20px;
        img { width: 100%; height: 100%; }
      }
      .content {
        .title {
          font-size: 20px;
          font-weight: 700;
          color: #b4becc;
          line-height: 28px;
          margin-bottom: 20px;
        }
        .font {
          font-size: 14px;
          color: #b4becc;
          line-height: 24px;
          margin-bottom: 10px;
        }
      }
    }

    /* ✅ 统一所有服务板块样式：AI板块已加入 */
    .enterpriseServices,
    .governmentServices,
    .AIManualAggregation,
    .cooperationbox,
    .aboutUsBox
    {
      .title {
        font-size: 16px;
        font-weight: 700;
        color: #ffffff;
        line-height: 24px;
        margin-bottom: 20px;
      }
      .content {
        .item {
          font-size: 14px;
          color: #b4becc;
          line-height: 24px;
          margin-bottom: 10px;
          cursor: pointer;
        }
      }
    }


    .followUsBox {
      width: 120px;
      text-align: center;
      .title {
        font-size: 16px;
        font-weight: 700;
        color: #ffffff;
        line-height: 24px;
        margin-bottom: 10px;
      }
      .content {
        .gongzhonghao {
          width: 120px;
          height: 120px;
        }
        p {
          margin-top: 10px;
          font-size: 14px;
          color: #b4becc;
          line-height: 24px;
        }
      }
    }

    .footer_bottom {
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      .item {
        margin-right: 40px;
        font-size: 12px;
        color: #96a2b2;
        a { color: #96a2b2; }
      }
    }
  }
}
</style>
